import { Component, Input, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'taly-instalments',
  templateUrl: './instalments.component.html',
  styleUrls: ['./instalments.component.scss']
})
export class InstalmentsComponent implements OnInit {

  sliderAmount:any=[];

  orderAmount:any;

  @Input() isLightTheam: boolean;

  @Input()
  set amounts(value: any) {
    this.orderAmount = value;
    this.setSliderAmount()
  }


  transferSignal = inject(SharedSignalsService);
  textDirection: string;

  constructor(public translationService: TranslationService,){
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection(); 
      setTimeout(() => {
        this.setSliderAmount();
      }, 10);
    });
  }

  ngOnInit(): void {
    
  }

  setSliderAmount(){
    this.sliderAmount = [
      {
        label:this.translationService.getLabelValue('LEARN_MORE_PAGE.TODAY'), 
        amount: this.orderAmount / 3
      },
      {
        label:this.translationService.getLabelValue('LEARN_MORE_PAGE.30_DAY'),
        amount: this.orderAmount / 3
      },
      {
        label:this.translationService.getLabelValue('LEARN_MORE_PAGE.60_DAY'),
        amount: this.orderAmount / 3
      },
      // {
      //   label:this.translationService.getLabelValue('LEARN_MORE_PAGE.90_DAY'),
      //   amount: this.orderAmount / 4
      // },
    ]
  }

}
